var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.669,
    height: 54.496,
    viewBox: "0 0 51.669 54.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(-1.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M38.126,0H6.459a4.8,4.8,0,0,0-4.8,4.8V49.7a4.805,4.805,0,0,0,4.8,4.8H38.126a4.805,4.805,0,0,0,4.8-4.8V4.8A4.8,4.8,0,0,0,38.126,0Zm2.331,49.7a2.333,2.333,0,0,1-2.331,2.331H6.459A2.334,2.334,0,0,1,4.128,49.7V4.8A2.333,2.333,0,0,1,6.459,2.469H38.126A2.333,2.333,0,0,1,40.456,4.8V49.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M37.571,6.095H8.894a.9.9,0,0,0-.9.9V17.006a.9.9,0,0,0,.9.9H37.571a.9.9,0,0,0,.9-.9V7a.9.9,0,0,0-.9-.9Z",
    transform: "translate(-0.94 -0.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M34.86,23.389h7.6V29.47h-7.6Z",
    transform: "translate(-4.93 -3.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M34.86,32.514h7.6v6.081h-7.6Z",
    transform: "translate(-4.93 -4.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M34.86,41.639h7.6V47.72h-7.6Z",
    transform: "translate(-4.93 -6.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M34.86,50.764h7.6v6.081h-7.6Z",
    transform: "translate(-4.93 -7.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M8.66,25.61H29.479v2.3H8.66Z",
    transform: "translate(-1.039 -3.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M8.66,34.735H29.479v2.3H8.66Z",
    transform: "translate(-1.039 -5.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M8.66,43.86H29.479v2.3H8.66Z",
    transform: "translate(-1.039 -6.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M8.66,52.985H29.479v2.3H8.66Z",
    transform: "translate(-1.039 -7.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M59.276,2.386H54.757a1.686,1.686,0,0,0-1.679,1.689V7.908h7.887V4.075a1.694,1.694,0,0,0-1.689-1.689Z",
    transform: "translate(-7.635 -0.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M53.078,44.782l1.649,4.234h4.585l1.654-4.234V10.14H53.078V44.782ZM56.41,13.474h1.172V37.932H56.41V13.474Z",
    transform: "translate(-7.635 -1.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M56.97,60.817a.533.533,0,0,0,.937,0l1.052-2.694H55.921l1.049,2.694Z",
    transform: "translate(-8.057 -8.631)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/NoteIcon.e9fbeae4e93373b0e0513194a95bf629.svg";
export { ForwardRef as ReactComponent };